import { render, staticRenderFns } from "./Construction.vue?vue&type=template&id=763f7830"
import script from "./Construction.vue?vue&type=script&lang=js"
export * from "./Construction.vue?vue&type=script&lang=js"
import style0 from "./Construction.vue?vue&type=style&index=0&id=763f7830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports